import { CanActivateFn, Router } from '@angular/router';
import { RoleName } from '@app/shared/enums/user.enum';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { appFeature } from '@app/core/store/app.reducer';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs';

export const roleGuard = (requiredRoles: RoleName[]): CanActivateFn => {
  return () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(appFeature.selectUser).pipe(
      filter(Boolean),
      map(user => {
        const allowedRoles = [...requiredRoles, RoleName.Admin];
        const isValidRoles = user.roles.some(item =>
          allowedRoles.includes(item.name)
        );

        if (isValidRoles) {
          return true;
        } else {
          router.navigate(['/not-access']);
          return false;
        }
      })
    );
  };
};
